/** Versión de la aplicación, mostrada en el pie y en el diálogo de ayuda. */
export const APP_VERSION = '1.0';
